import React from "react";
import PropTypes from "prop-types";
import { useLinks } from "hooks";
import { margins } from "style";
import { FormattedMessage } from "react-intl";
import { PrimaryLink } from "components/Links";
import { Description } from "components/DisplayBox";

/**
 * ApplicantPreviewLink
 *
 * @param {Object} applicant
 */
const ApplicantPreviewLink = ({ applicant }) => {
  if (!applicant) return null;

  const links = useLinks();

  return (
    <>
      <PrimaryLink to={links.applicant_preview(applicant.uuid)} target="_blank" rel="noopener noreferrer">
        <FormattedMessage id="Missions.MissionRole.ApplicationDetailsModal.ViewApplication" />
      </PrimaryLink>
      <Description marginBottom={margins.none}>
        <FormattedMessage
          id="Missions.MissionRole.ApplicationDetailsModal.ViewApplication.Description"
          values={{ pin: applicant.mission.organization.applicationsPin }}
        />
      </Description>
    </>
  );
};

ApplicantPreviewLink.propTypes = {
  applicant: PropTypes.object.isRequired,
};

export default ApplicantPreviewLink;
